<template>
	<portlet class="form-query" hide-title="true">
		<el-row>
			<el-col :span="12">
				<!-- <base-select
					:label-width="labelConfig.width"
					v-model="params.materialCode"
					:remote="true"
					:filterable="true"
					apiName="Material_SearchMaterial_CodeOrDesc"
					label="款号"
					placeholder="款号"></base-select> -->
					<base-string
						:label-width="labelConfig.width"
						v-model="params.materialCode"
						label="款号"
					placeholder="款号"></base-string>
			</el-col>
			<el-col :span="12">
				<base-select
					:label-width="labelConfig.width"
					v-model="params.brands"
					:is-require="true"
					label="品牌"
					apiName="POST_SPS_SYS_ENUM_URL"
					:params="{typeCode: 'Brand'}"
					:optionsFilter="optionsFilter"
					placeholder="品牌"></base-select>
			</el-col>
			<el-col :span="12">
				<base-date-picker
					:label-width="labelConfig.width"
					v-model="params.years"
					:is-require="true"
					type="year"
					format="yyyy"
					valueFormat="{y}"
					label="年份"
					placeholder="年份"></base-date-picker>
			</el-col>
			<el-col :span="12">
				<base-select
					:label-width="labelConfig.width"
					v-model="params.periods"
					:is-require="true"
					label="期数"
					apiName="POST_SPS_SYS_ENUM_URL"
					:params="{typeCode: 'Periods'}"
					placeholder="期数"></base-select>
			</el-col>
		</el-row>
		<transition name="fade">
			<el-row v-show="isShowParams">
				<el-col :span="12">
					<base-select
						:label-width="labelConfig.width"
						v-model="params.materialDesc"
						:remote="true"
						:filterable="true"
						apiName="Material_SearchMaterial_CodeOrDesc"
						label="款名"
						placeholder="款名"></base-select>
				</el-col>
				<el-col :span="12">
					<base-select
						:label-width="labelConfig.width"
						v-model="params.ProductionCategory"
						label="生产类别"
						apiName="POST_SPS_SYS_ENUM_URL"
						:params="{typeCode: 'ProductionCategory'}"
						placeholder="生产类别"></base-select>
				</el-col>
				<el-col :span="12">
					<base-select
						:label-width="labelConfig.width"
						v-model="params.S001"
						label="系列"
						apiName="POST_SPS_SYS_ENUM_URL"
						:params="[
							{typeCode: 'Series_1'},
							{typeCode: 'Series_2'},
							{typeCode: 'Series_3'},
							{typeCode: 'Series_4'},
							{typeCode: 'Series_5'},
							{typeCode: 'Series_6'},
							{typeCode: 'Series_7'},
							{typeCode: 'Series_8'},
							{typeCode: 'Series_C'},
							{typeCode: 'Series_W'}]"
						placeholder="系列"></base-select>
				</el-col>
				<el-col :span="12">
					<base-select
						:label-width="labelConfig.width"
						v-model="params.waveCode"
						label="波段"
						apiName="POST_SPS_SYS_ENUM_URL"
						:params="{typeCode: 'Wave'}"
						:filterable="true"
						:max="300"
						placeholder="波段"></base-select>
				</el-col>
			</el-row>
		</transition>
		
		<el-row type="flex" justify="end">
			<el-button type="primary" size="small" @click="handleSearch">查询</el-button>
			<el-button size="small" @click="handleReset">重置</el-button>
			<el-button type="primary" size="small" @click="handleShowInput">展开</el-button>
		</el-row>
	</portlet>
</template>
<script>


export default {
	name: 'special-head',
    props: {
		params: {
			type: Object,
			default: () => ({
				materialCode: null,
				brands: null,
                years: null,
				periods: null,
                materialDesc: null,
                ProductionCategory: null,
                S001: null,
                waveCode: null
			})
		}
	},
	methods: {
		handleSearch() {
			this.$emit('handleSearch', this.params)
		},
		handleReset() {
			this.$emit('handleReset');
		},
		handleShowInput() {
			this.isShowParams = !this.isShowParams
		},
		optionsFilter(item) {
			if (this.$store.getters.isAdmin) return true;
			return this.$store.getters.brandCodeList.includes(item.code) 
		}
	},
    data() {
        return {
			isShowParams: false,
			labelConfig: {
				width: 60
			}
        }
    }
}
</script>

<style scoped>
	.fade-enter{
		transition: all 1s linear;
		height: auto;  
		overflow: auto;  
	}
	.fade-leave, .fade-leave-active{
		transition: all 1s linear;
		height: 0;
		overflow: hidden;  
	}
</style>
